// Build an absolute URL to an IFE endpoint using the host that's been wired
// for the current environment (window.App.ifeHost, populated server-side from
// the IFE_HOST_URL env var). In fullstack this resolves to https://ife.ifttt.me;
// in production it resolves to https://ifttt.com (or whichever IFE ingress is
// configured). Tests stub window.App.ifeHost in vitest-setup.
//
// CORS: IFE is responsible for allowing the web origin on these routes.

export function ifeUrl(path: string): string {
  const host = (window as unknown as { App?: { ifeHost?: string } }).App?.ifeHost ?? ""
  if (!path.startsWith("/")) {
    return `${host}/${path}`
  }
  return `${host}${path}`
}
